// src/pages/RegisterPage.jsx
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { apiUrl } from "../config/api";

function RegisterPage() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    nationalCode: "",
    phone: "",
    goldsmithName: "",
    shopAddress: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // بررسی فیلدهای خالی
      const emptyFields = Object.entries(formData)
        .filter(([_, value]) => !value.trim())
        .map(([key]) => key);

      if (emptyFields.length > 0) {
        throw new Error(`فیلدهای ${emptyFields.join("، ")} الزامی هستند`);
      }

      // اعتبارسنجی شماره تماس
      if (!/^09\d{9}$/.test(formData.phone)) {
        throw new Error("شماره تماس نامعتبر است");
      }

      // اعتبارسنجی کد ملی
      if (!/^\d{10}$/.test(formData.nationalCode)) {
        throw new Error("کد ملی باید ۱۰ رقم باشد");
      }

      const response = await fetch(apiUrl("/api/auth/register"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      // بررسی وضعیت پاسخ
      if (response.status === 404) {
        throw new Error("سرور پیدا نشد. لطفاً از اتصال به اینترنت مطمئن شوید");
      }

      if (response.status === 500) {
        throw new Error("خطای سرور. لطفاً بعداً تلاش کنید");
      }

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || data.error || "خطا در ثبت‌نام");
      }

      toast.success(data.message || "ثبت‌نام با موفقیت انجام شد!");
      navigate("/pending");

    } catch (error) {
      console.error("خطای ثبت‌نام:", error);
      toast.error(error.message || "خطا در برقراری ارتباط با سرور");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-card">
        <h2 className="register-title">📝 ثبت‌نام زرگر</h2>
        <p className="register-subtitle">
          اطلاعات خود را برای ثبت‌نام وارد کنید
        </p>

        <form onSubmit={handleSubmit} className="register-form">
          <div className="form-row">
            <div className="form-group">
              <label>نام</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="نام خود را وارد کنید"
                required
              />
            </div>

            <div className="form-group">
              <label>نام خانوادگی</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="نام خانوادگی خود را وارد کنید"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>کد ملی</label>
              <input
                type="text"
                name="nationalCode"
                value={formData.nationalCode}
                onChange={handleChange}
                placeholder="کد ملی ۱۰ رقمی"
                maxLength={10}
                required
              />
            </div>

            <div className="form-group">
              <label>شماره تماس</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="09123456789"
                maxLength={11}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>نام زرگری (تجاری)</label>
            <input
              type="text"
              name="goldsmithName"
              value={formData.goldsmithName}
              onChange={handleChange}
              placeholder="نام مغازه یا واحد صنفی"
              required
            />
          </div>

          <div className="form-group">
            <label>آدرس مغازه</label>
            <textarea
              name="shopAddress"
              value={formData.shopAddress}
              onChange={handleChange}
              placeholder="آدرس کامل مغازه"
              rows={3}
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="submit-btn"
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                در حال ثبت...
              </>
            ) : (
              "ثبت‌نام"
            )}
          </button>
          <div className="login-footer">
          <p>
            حساب کاربری دارید ؟{" "}
            <Link to="/loginpage" className="login-link">
              وارد شوید
            </Link>
          </p>
        </div>
        </form>
      </div>
    </div>
  );
}

export default RegisterPage;
